import { createReducer, on, Action } from '@ngrx/store'
import * as SelectedAuctionActions from './selected-auction.actions'
import { AuctionsEntity } from './selected-auction.models'
import { formatForQuillEditor } from 'libs/gb-dashboard/shared/ui/src/lib/gb-quill-editor/gb-quill-editor-formatter'

export const SELECTED_AUCTION_FEATURE_KEY = 'selectedAuction'

export interface SelectedAuctionState {
  auction: AuctionsEntity | null
  loaded: boolean
  saving: boolean
}

export interface SelectedAuctionPartialState {
  readonly [SELECTED_AUCTION_FEATURE_KEY]: SelectedAuctionState
}

export const initialSelectedAuctionState: SelectedAuctionState = {
  auction: null,
  loaded: true,
  saving: false,
}

const reducer = createReducer(
  initialSelectedAuctionState,
  on(SelectedAuctionActions.initSelectedAuction, () => ({
    ...initialSelectedAuctionState,
  })),
  on(
    SelectedAuctionActions.setSelectedAuction,
    SelectedAuctionActions.syncAuctionSuccess,
    SelectedAuctionActions.updateAuctionSuccess,
    SelectedAuctionActions.pauseAuctionSuccess,
    SelectedAuctionActions.openAuctionSuccess,
    SelectedAuctionActions.closeAuctionSuccess,
    (state, { auction }) => ({
      auction: { ...auction, terms_and_conditions: formatForQuillEditor(auction.terms_and_conditions) },
      loaded: true,
      saving: false,
    }),
  ),
  on(SelectedAuctionActions.syncAuctionFailure, (state) => ({
    ...state,
    loaded: true,
  })),
  on(SelectedAuctionActions.updateAuction, (state) => ({
    ...state,
    saving: true,
  })),
  on(
    SelectedAuctionActions.updateAuctionFailure,
    SelectedAuctionActions.pauseAuctionFailure,
    SelectedAuctionActions.openAuctionFailure,
    SelectedAuctionActions.closeAuctionFailure,
    (state) => ({
      ...state,
      saving: false,
    }),
  ),
  on(SelectedAuctionActions.updateAuctionForRealtime, (state, { update }) => ({
    ...state,
    auction: state.auction ? { ...state.auction, ...update.changes } : state.auction,
  })),
)

export function selectedAuctionReducer(state: SelectedAuctionState | undefined, action: Action) {
  return reducer(state, action)
}
